{
    "image_upload_error": "Échec du téléchargement de l'image. Essayez de recharger cette page et de sélectionner une image à nouveau.",
    "search_placeholder": "Rechercher des photos et des illustrations",
    "search": "Chercher",
    "photo": "Image",
    "image_by": "par",
    "free_photos_from": "Images de stock gratuites de",
    "uploading": "Envoi en cours",
    "cancel": "Annuler",
    "select": "Sélectionner"
}
